'use client'
import { Button } from '@/components/Button'
import { Popup } from '@/components/Popup'
import { apiService } from '@/services/Api'
import { AcceptPolicy } from '@/shared/Auth/components/AcceptPolicy'
import { userStore } from '@/store/User'
import { observer } from 'mobx-react-lite'
import { FunctionComponent, useCallback, useState } from 'react'
import { toast } from 'react-toastify'
import styles from './ConfirmationOfferPopup.module.scss'

interface ConfirmationOfferPopupProps {}
export const ConfirmationOfferPopup: FunctionComponent<ConfirmationOfferPopupProps> =
  observer(() => {
    const [isAccepted, setIsAccepted] = useState(false)

    const changeAccepted = useCallback((value: boolean) => {
      setIsAccepted(value)
    }, [])

    const [isLoading, setIsLoading] = useState(false)

    const accept = useCallback(async () => {
      try {
        setIsLoading(true)
        const response = await apiService.user.acceptAgreement()
        if (response.status) {
          userStore.setData(response.data.user)
        } else {
          toast.error('Что то пошло не так! Попробуйте позже')
        }
      } catch {
        toast.error('Что то пошло не так! Попробуйте позже')
      } finally {
        setIsLoading(false)
      }
    }, [])

    return (
      <Popup className={styles.popup} withoutClose>
        <div className={styles.content}>
          <h2 className={styles.title}>Обновление публичной оферты</h2>

          <div className={styles.divider} />

          <p className={styles.description}>
            Мы обновили условия публичной оферты. Чтобы продолжить работу,
            ознакомьтесь с новой редакцией и подтвердите согласие.
          </p>

          <AcceptPolicy value={isAccepted} onChange={changeAccepted} />
          <Button
            className={styles.button}
            disabled={!isAccepted}
            onClick={accept}
            isLoading={isLoading}
          >
            Продолжить
          </Button>
        </div>
      </Popup>
    )
  })
